import { combineReducers, createStore, compose, applyMiddleware } from "redux";
import { routeReducer, syncHistory } from "react-router-redux";
import { browserHistory } from "react-router";
import { composeWithDevTools } from "@redux-devtools/extension";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import { forms, FormState } from "../reducers";

export type RootState = {
	routing: any;
	forms: FormState;
};

const logger = createLogger();
const reduxRouterMiddleware = syncHistory(browserHistory);
const rootReducer = combineReducers<RootState>({
	routing: routeReducer,
	forms,
});

let store;

if (process.env.NODE_ENV === "production") {
	// @ts-ignore
	store = createStore(rootReducer, compose(applyMiddleware(thunk, reduxRouterMiddleware)));
} else {
	// @ts-ignore
	store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk, reduxRouterMiddleware, logger)));
}

export { store };
